import { MediaCard } from './MediaCard';
import type { Media } from '@wineryxplorer/shared';

export interface MediaGridProps {
  media: Media[];
  selectedMedia?: Set<string>;
  onMediaClick?: (media: Media) => void;
  onSelectMedia?: (media: Media) => void;
  onToggleSelectMedia?: (media: Media) => void;
  showCheckboxes?: boolean;
  showPublicationStatus?: boolean;
  showTags?: boolean;
  showUploader?: boolean;
  showSource?: boolean;
  readOnly?: boolean;
  isLoading?: boolean;
  emptyMessage?: string;
  className?: string;
}

export function MediaGrid({
  media,
  selectedMedia = new Set(),
  onMediaClick,
  onSelectMedia,
  onToggleSelectMedia,
  showCheckboxes = false,
  showPublicationStatus = true,
  showTags = true,
  showUploader = false,
  showSource = false,
  readOnly = false,
  isLoading = false,
  emptyMessage = 'No media found',
  className = '',
}: MediaGridProps) {
  if (isLoading) {
    return (
      <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 ${className}`}>
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            className="bg-gray-200 rounded-lg aspect-square animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (media.length === 0) {
    return (
      <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
        <svg
          className="w-16 h-16 text-gray-400 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <p className="text-gray-500 text-lg font-medium">{emptyMessage}</p>
        <p className="text-gray-400 text-sm mt-1">
          Upload some images to get started
        </p>
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 ${className}`}>
      {media.map((item) => (
        <MediaCard
          key={item.id}
          media={item}
          isSelected={selectedMedia.has(item.id)}
          onClick={onMediaClick}
          onSelect={onSelectMedia}
          onToggleSelect={onToggleSelectMedia}
          showCheckbox={showCheckboxes}
          showPublicationStatus={showPublicationStatus}
          showTags={showTags}
          showUploader={showUploader}
          showSource={showSource}
          readOnly={readOnly}
        />
      ))}
    </div>
  );
}